export default "__VITE_ASSET__DShR4y1x__"